export const roundCurrency = value => typeof value !== 'number' ? value : Math.round(value * 100 + 0.00001) / 100
export const toCurrency = value => typeof value !== 'number' ? value : roundCurrency(value).toLocaleString(undefined, { style: 'currency', currency: 'EUR' }).replaceAll(' ', '.')
export function Currency({ value }) {
    return <div className="text-right max-w-[90px] whitespace-nowrap">{toCurrency(value)}</div>
}
export const postalCodeToCommune = postalCode => ({
    '1000': 'Bruxelles',
    '1020': 'Laeken',
    '1030': 'Schaerbeek',
    '1040': 'Etterbeek',
    '1050': 'Ixelles',
    '1060': 'Saint-Gilles',
    '1070': 'Anderlecht',
    '1080': 'Molenbeek-Saint-Jean',
    '1081': 'Koekelberg',
    '1082': 'Berchem-Sainte-Agathe',
    '1083': 'Ganshoren',
    '1090': 'Jette',
    '1120': 'Neder-Over-Heembeek',
    '1130': 'Haren',
    '1140': 'Evere',
    '1150': 'Woluwe-Saint-Pierre',
    '1160': 'Auderghem',
    '1170': 'Watermael-Boitsfort',
    '1180': 'Uccle',
    '1190': 'Forest',
    '1200': 'Woluwe-Saint-Lambert',
    '1210': 'Saint-Josse-Ten-Noode',
    '1300': 'Wavre',
    '1301': 'Bierges',
    '1310': 'La Hulpe',
    '1315': 'Opprebais',
    '1320': 'Nodebais',
    '1325': 'Longueville',
    '1330': 'Rixensart',
    '1331': 'Rosières',
    '1332': 'Genval',
    '1340': 'Ottignies',
    '1341': 'Céroux-Mousty',
    '1342': 'Limelette',
    '1348': 'Louvain-La-Neuve',
    '1350': 'Jauche',
    '1357': 'Opheylissem',
    '1360': 'Thorembais-Saint-Trond',
    '1367': 'Grand-Rosière-Hottomont',
    '1370': 'Saint-Jean-Geest',
    '1380': 'Maransart',
    '1390': 'Nethen',
    '1400': 'Monstreux',
    '1401': 'Baulers',
    '1402': 'Thines',
    '1404': 'Bornival',
    '1410': 'Waterloo',
    '1420': "Braine-L'alleud",
    '1421': 'Ophain-Bois-Seigneur-Isaac',
    '1428': 'Lillois-Witterzée',
    '1430': 'Rebecq',
    '1435': 'Mont-Saint-Guibert',
    '1440': 'Braine-Le-Château',
    '1450': 'Cortil-Noirmont',
    '1457': 'Nil-Saint-Vincent-Saint-Martin',
    '1460': 'Virginal-Samme',
    '1461': 'Haut-Ittre',
    '1470': 'Bousval',
    '1471': 'Loupoigne',
    '1472': 'Vieux-Genappe',
    '1473': 'Glabais',
    '1474': 'Ways',
    '1476': 'Houtain-Le-Val',
    '1480': 'Tubize',
    '1490': 'Court-Saint-Etienne',
    '1495': 'Tilly',
    '1500': 'Halle',
    '1501': 'Buizingen',
    '1502': 'Lembeek',
    '1540': 'Herfelingen',
    '1541': 'Sint-Pieters-Kapelle',
    '1547': 'Biévène',
    '1560': 'Hoeilaart',
    '1570': 'Vollezele',
    '1600': 'Sint-Laureins-Berchem',
    '1601': 'Ruisbroek',
    '1602': 'Vlezenbeek',
    '1620': 'Drogenbos',
    '1630': 'Linkebeek',
    '1640': 'Rhode-Saint-Genèse',
    '1650': 'Beersel',
    '1651': 'Lot',
    '1652': 'Alsemberg',
    '1653': 'Dworp',
    '1654': 'Huizingen',
    '1670': 'Heikruis',
    '1671': 'Elingen',
    '1673': 'Beert',
    '1674': 'Bellingen',
    '1700': 'Sint-Martens-Bodegem',
    '1701': 'Itterbeek',
    '1702': 'Groot-Bijgaarden',
    '1703': 'Schepdaal',
    '1730': 'Bekkerzeel',
    '1731': 'Zellik',
    '1740': 'Ternat',
    '1741': 'Wambeek',
    '1742': 'Sint-Katherina-Lombeek',
    '1745': 'Opwijk',
    '1750': 'Sint-Martens-Lennik',
    '1755': 'Oetingen',
    '1760': 'Roosdaal',
    '1761': 'Borchtlombeek',
    '1770': 'Liedekerke',
    '1780': 'Wemmel',
    '1785': 'Brussegem',
    '1790': 'Hekelgem',
    '1800': 'Peutie',
    '1820': 'Melsbroek',
    '1830': 'Machelen',
    '1831': 'Diegem',
    '1840': 'Malderen',
    '1850': 'Grimbergen',
    '1851': 'Humbeek',
    '1852': 'Beigem',
    '1853': 'Strombeek-Bever',
    '1860': 'Meise',
    '1861': 'Wolvertem',
    '1880': 'Ramsdonk',
    '1910': 'Kampenhout',
    '1930': 'Zaventem',
    '1932': 'Sint-Stevens-Woluwe',
    '1933': 'Sterrebeek',
    '1950': 'Kraainem',
    '1970': 'Wezembeek-Oppem',
    '1980': 'Eppegem',
    '1981': 'Hofstade',
    '1982': 'Weerde',
    '2000': 'Antwerpen',
    '2018': 'Antwerpen',
    '2020': 'Antwerpen',
    '2030': 'Antwerpen',
    '2040': 'Lillo',
    '2050': 'Antwerpen',
    '2060': 'Antwerpen',
    '2070': 'Zwijndrecht',
    '2100': 'Deurne',
    '2110': 'Wijnegem',
    '2140': 'Borgerhout',
    '2150': 'Borsbeek',
    '2160': 'Wommelgem',
    '2170': 'Merksem',
    '2180': 'Ekeren',
    '2200': 'Morkhoven',
    '2220': 'Heist-Op-Den-Berg',
    '2221': 'Booischot',
    '2222': 'Itegem',
    '2223': 'Schriek',
    '2230': 'Ramsel',
    '2235': 'Houtvenne',
    '2240': 'Viersel',
    '2242': 'Pulderbos',
    '2243': 'Pulle',
    '2250': 'Olen',
    '2260': 'Westerlo',
    '2270': 'Herenthout',
    '2275': 'Wechelderzande',
    '2280': 'Grobbendonk',
    '2288': 'Bouwel',
    '2290': 'Vorselaar',
    '2300': 'Turnhout',
    '2310': 'Rijkevorsel',
    '2320': 'Hoogstraten',
    '2321': 'Meer',
    '2322': 'Minderhout',
    '2323': 'Wortel',
    '2328': 'Meerle',
    '2330': 'Merksplas',
    '2340': 'Vlimmeren',
    '2350': 'Vosselaar',
    '2360': 'Oud-Turnhout',
    '2370': 'Arendonk',
    '2380': 'Ravels',
    '2381': 'Weelde',
    '2382': 'Poppel',
    '2387': 'Baarle-Hertog',
    '2390': 'Westmalle',
    '2400': 'Mol',
    '2430': 'Vorst',
    '2431': 'Veerle',
    '2440': 'Geel',
    '2450': 'Meerhout',
    '2460': 'Tielen',
    '2470': 'Retie',
    '2480': 'Dessel',
    '2490': 'Balen',
    '2491': 'Olmen',
    '2500': 'Lier',
    '2520': 'Emblem',
    '2530': 'Boechout',
    '2531': 'Vremde',
    '2540': 'Hove',
    '2547': 'Lint',
    '2550': 'Kontich',
    '2560': 'Nijlen',
    '2570': 'Duffel',
    '2580': 'Beerzel',
    '2590': 'Gestel',
    '2600': 'Berchem',
    '2610': 'Wilrijk',
    '2620': 'Hemiksem',
    '2627': 'Schelle',
    '2630': 'Aartselaar',
    '2640': 'Mortsel',
    '2650': 'Edegem',
    '2660': 'Hoboken',
    '2800': 'Walem',
    '2801': 'Heffen',
    '2811': 'Leest',
    '2812': 'Muizen',
    '2820': 'Bonheiden',
    '2830': 'Blaasveld',
    '2840': 'Terhagen',
    '2845': 'Niel',
    '2850': 'Boom',
    '2860': 'Sint-Katelijne-Waver',
    '2861': 'Onze-Lieve-Vrouw-Waver',
    '2870': 'Liezele',
    '2880': 'Hingene',
    '2890': 'Oppuurs',
    '2900': 'Schoten',
    '2910': 'Essen',
    '2920': 'Kalmthout',
    '2930': 'Brasschaat',
    '2940': 'Hoevenen',
    '2950': 'Kapellen',
    '2960': 'Brecht',
    '2970': 'Schilde',
    '2980': 'Zoersel',
    '2990': 'Wuustwezel',
    '3000': 'Leuven',
    '3001': 'Heverlee',
    '3010': 'Kessel Lo',
    '3012': 'Wilsele',
    '3018': 'Wijgmaal',
    '3020': 'Herent',
    '3040': 'Loonbeek',
    '3050': 'Oud-Heverlee',
    '3051': 'Sint-Joris-Weert',
    '3052': 'Blanden',
    '3053': 'Haasrode',
    '3054': 'Vaalbeek',
    '3060': 'Korbeek-Dijle',
    '3061': 'Leefdaal',
    '3070': 'Kortenberg',
    '3071': 'Erps-Kwerps',
    '3078': 'Everberg',
    '3080': 'Duisburg',
    '3090': 'Overijse',
    '3110': 'Rotselaar',
    '3111': 'Wezemaal',
    '3118': 'Werchter',
    '3120': 'Tremelo',
    '3128': 'Baal',
    '3130': 'Begijnendijk',
    '3140': 'Keerbergen',
    '3150': 'Wespelaar',
    '3190': 'Boortmeerbeek',
    '3191': 'Hever',
    '3200': 'Aarschot',
    '3201': 'Langdorp',
    '3202': 'Rillaar',
    '3210': 'Lubbeek',
    '3211': 'Binkom',
    '3212': 'Pellenberg',
    '3220': 'Kortrijk-Dutsel',
    '3221': 'Nieuwrode',
    '3270': 'Scherpenheuvel-Zichem',
    '3271': 'Zichem',
    '3272': 'Messelbroek',
    '3290': 'Deurne',
    '3293': 'Kaggevinne',
    '3294': 'Molenstede',
    '3300': 'Vissenaken',
    '3320': 'Meldert',
    '3321': 'Outgaarden',
    '3350': 'Orsmaal-Gussenhoven',
    '3360': 'Opvelp',
    '3370': 'Roosbeek',
    '3380': 'Glabbeek',
    '3381': 'Kapellen',
    '3384': 'Attenrode',
    '3390': 'Tielt',
    '3391': 'Meensel-Kiezegem',
    '3400': 'Ezemaal',
    '3401': 'Walshoutem',
    '3404': 'Neerlanden',
    '3440': 'Zoutleeuw',
    '3450': 'Grazen',
    '3454': 'Rummen',
    '3460': 'Bekkevoort',
    '3461': 'Molenbeek-Wersbeek',
    '3470': 'Sint-Margriete-Houtem',
    '3471': 'Hoeleden',
    '3472': 'Kersbeek-Miskom',
    '3473': 'Waanrode',
    '3500': 'Hasselt',
    '3501': 'Wimmertingen',
    '3510': 'Kermt',
    '3511': 'Kuringen',
    '3512': 'Stevoort',
    '3520': 'Zonhoven',
    '3530': 'Houthalen-Helchteren',
    '3540': 'Berbroek',
    '3545': 'Zelem',
    '3550': 'Heusden-Zolder',
    '3560': 'Lummen',
    '3570': 'Alken',
    '3580': 'Beringen',
    '3581': 'Beverlo',
    '3582': 'Koersel',
    '3583': 'Paal',
    '3590': 'Diepenbeek',
    '3600': 'Genk',
    '3620': 'Gellik',
    '3621': 'Rekem',
    '3630': 'Vucht',
    '3631': 'Uikhoven',
    '3640': 'Molenbeersel',
    '3650': 'Stokkem',
    '3660': 'Opglabbeek',
    '3665': 'As',
    '3668': 'Niel-Bij-As',
    '3670': 'Meeuwen',
    '3680': 'Opoeteren',
    '3690': 'Zutendaal',
    '3700': 'Widooie',
    '3717': 'Herstappe',
    '3720': 'Kortessem',
    '3721': 'Vliermaalroot',
    '3722': 'Wintershoven',
    '3723': 'Guigoven',
    '3724': 'Vliermaal',
    '3730': 'Werm',
    '3732': 'Schalkhoven',
    '3740': 'Mopertingen',
    '3742': 'Martenslinde',
    '3746': 'Hoelbeek',
    '3770': 'Millen',
    '3790': 'Fourons',
    '3791': 'Remersdaal',
    '3792': 'Fouron-Saint-Pierre',
    '3793': 'Teuven',
    '3798': 'Fouron-Le-Comte',
    '3800': 'Zepperen',
    '3803': 'Gorsem',
    '3806': 'Velm',
    '3830': 'Wellen',
    '3831': 'Herten',
    '3832': 'Ulbeek',
    '3840': 'Kolmont',
    '3850': 'Wijer',
    '3870': 'Vechmaal',
    '3890': 'Boekhout',
    '3891': 'Mielen-Boven-Aalst',
    '3900': 'Overpelt',
    '3910': 'Neerpelt',
    '3920': 'Lommel',
    '3930': 'Hamont-Achel',
    '3940': 'Hechtel',
    '3941': 'Eksel',
    '3945': 'Oostham',
    '3950': 'Bocholt',
    '3960': 'Gerdingen',
    '3970': 'Leopoldsburg',
    '3971': 'Heppen',
    '3980': 'Tessenderlo',
    '3990': 'Kleine-Brogel',
    '4000': 'Liège',
    '4020': 'Wandre',
    '4030': 'Grivegnee',
    '4031': 'Angleur',
    '4032': 'Chênee',
    '4040': 'Herstal',
    '4041': 'Vottem',
    '4042': 'Liers',
    '4050': 'Chaudfontaine',
    '4051': 'Vaux-Sous-Chèvremont',
    '4052': 'Beaufays',
    '4053': 'Embourg',
    '4100': 'Boncelles',
    '4101': 'Jemeppe-Sur-Meuse',
    '4102': 'Ougrée',
    '4120': 'Rotheux-Rimière',
    '4121': 'Neuville-En-Condroz',
    '4122': 'Plainevaux',
    '4130': 'Esneux',
    '4140': 'Sprimont',
    '4141': 'Louveigné',
    '4160': 'Anthisnes',
    '4161': 'Villers-Aux-Tours',
    '4162': 'Hody',
    '4163': 'Tavier',
    '4170': 'Comblain-Au-Pont',
    '4171': 'Poulseur',
    '4180': 'Comblain-La-Tour',
    '4181': 'Filot',
    '4190': 'Xhoris',
    '4210': 'Oteppe',
    '4217': 'Héron',
    '4218': 'Couthuin',
    '4219': 'Wasseiges',
    '4250': 'Lens-Saint-Servais',
    '4252': 'Omal',
    '4253': 'Darion',
    '4254': 'Ligney',
    '4257': 'Corswarem',
    '4260': 'Fallais',
    '4261': 'Latinne',
    '4263': 'Tourinne',
    '4280': 'Bertrée',
    '4287': 'Racour',
    '4300': 'Oleye',
    '4317': 'Viemme',
    '4340': 'Othée',
    '4342': 'Hognoul',
    '4347': 'Roloux',
    '4350': 'Pousset',
    '4351': 'Hodeige',
    '4357': 'Jeneffe',
    '4360': 'Grandville',
    '4367': 'Thys',
    '4400': 'Flémalle-Grande',
    '4420': 'Saint-Nicolas',
    '4430': 'Ans',
    '4431': 'Loncin',
    '4432': 'Alleur',
    '4450': 'Slins',
    '4451': 'Voroux-Lez-Liers',
    '4452': 'Paifve',
    '4453': 'Villers-Saint-Siméon',
    '4458': 'Fexhe-Slins',
    '4460': 'Bierset',
    '4470': 'Saint-Georges-Sur-Meuse',
    '4480': 'Ehein',
    '4500': 'Tihange',
    '4520': 'Wanze',
    '4530': 'Villers-Le-Bouillet',
    '4537': 'Bodegnée',
    '4540': 'Ombret',
    '4550': 'Yernée-Fraineux',
    '4557': 'Tinlot',
    '4560': 'Les Avins',
    '4570': 'Marchin',
    '4577': 'Outrelouxhe',
    '4590': 'Ellemelle',
    '4600': 'Lixhe',
    '4601': 'Argenteau',
    '4602': 'Cheratte',
    '4606': 'Saint-André',
    '4607': 'Feneur',
    '4608': 'Warsage',
    '4610': 'Bellaire',
    '4620': 'Fléron',
    '4621': 'Retinne',
    '4623': 'Magnée',
    '4624': 'Romsée',
    '4630': 'Ayeneux',
    '4631': 'Evegnée',
    '4632': 'Cérexhe-Heuseux',
    '4633': 'Melen',
    '4650': 'Julémont',
    '4651': 'Battice',
    '4652': 'Xhendelesse',
    '4653': 'Bolland',
    '4654': 'Charneux',
    '4670': 'Mortier',
    '4671': 'Saive',
    '4672': 'Saint-Remy',
    '4680': 'Oupeye',
    '4681': 'Hermalle-Sous-Argenteau',
    '4682': 'Houtain-Saint-Siméon',
    '4683': 'Vivegnis',
    '4684': 'Haccourt',
    '4690': 'Roclenge-Sur-Geer',
    '4700': 'Eupen',
    '4701': 'Kettenis',
    '4710': 'Lontzen',
    '4711': 'Walhorn',
    '4720': 'La Calamine',
    '4721': 'Neu-Moresnet',
    '4728': 'Hergenrath',
    '4730': 'Raeren',
    '4731': 'Eynatten',
    '4750': 'Butgenbach',
    '4760': 'Manderfeld',
    '4761': 'Rocherath',
    '4770': 'Meyerode',
    '4771': 'Heppenbach',
    '4780': 'Saint-Vith',
    '4782': 'Schoenberg',
    '4783': 'Lommersweiler',
    '4784': 'Crombach',
    '4790': 'Reuland',
    '4791': 'Thommen',
    '4800': 'Verviers',
    '4801': 'Stembert',
    '4802': 'Heusy',
    '4820': 'Dison',
    '4821': 'Andrimont',
    '4830': 'Limbourg',
    '4831': 'Bilstain',
    '4834': 'Goé',
    '4837': 'Membach',
    '4840': 'Welkenraedt',
    '4841': 'Henri-Chapelle',
    '4845': 'Jalhay',
    '4850': 'Plombières',
    '4851': 'Sippenaeken',
    '4852': 'Hombourg',
    '4860': 'Cornesse',
    '4861': 'Soiron',
    '4870': 'Fraipont',
    '4877': 'Olne',
    '4880': 'Aubel',
    '4890': 'Thimister-Clermont',
    '4900': 'Spa',
    '4910': 'Theux',
    '4920': 'Harzé',
    '4950': 'Waimes',
    '4960': 'Bevercé',
    '4970': 'Stavelot',
    '4980': 'Wanne',
    '4983': 'Basse-Bodeux',
    '4987': 'Stoumont',
    '4990': 'Arbrefontaine',
    '5000': 'Namur',
    '5001': 'Belgrade',
    '5002': 'Saint-Servais',
    '5003': 'Saint-Marc',
    '5004': 'Bouge',
    '5020': 'Temploux',
    '5021': 'Boninne',
    '5022': 'Cognelée',
    '5024': 'Gelbressée',
    '5030': 'Grand-Manil',
    '5031': 'Grand-Leez',
    '5032': 'Mazy',
    '5060': 'Sambreville',
    '5070': 'Sart-Eustache',
    '5080': 'Warisoulx',
    '5081': 'Bovesse',
    '5100': 'Wépion',
    '5101': 'Loyers',
    '5140': 'Sombreffe',
    '5150': 'Soye',
    '5170': 'Profondeville',
    '5190': 'Spy',
    '5300': 'Thon',
    '5310': 'Upigny',
    '5330': 'Sart-Bernard',
    '5332': 'Crupet',
    '5333': 'Sorinne-La-Longue',
    '5334': 'Florée',
    '5336': 'Courrière',
    '5340': 'Faulx-Les-Tombes',
    '5350': 'Ohey',
    '5351': 'Haillot',
    '5353': 'Goesnes',
    '5354': 'Jallet',
    '5360': 'Natoye',
    '5361': 'Scy',
    '5362': 'Achet',
    '5363': 'Emptinne',
    '5364': 'Schaltin',
    '5370': 'Flostoy',
    '5372': 'Méan',
    '5374': 'Maffe',
    '5376': 'Miécret',
    '5377': 'Somme-Leuze',
    '5380': 'Pontillas',
    '5500': 'Dréhance',
    '5501': 'Lisogne',
    '5502': 'Thynes',
    '5503': 'Sorinnes',
    '5504': 'Foy-Notre-Dame',
    '5520': 'Onhaye',
    '5521': 'Serville',
    '5522': 'Falaen',
    '5523': 'Weillen',
    '5524': 'Gerin',
    '5530': 'Godinne',
    '5537': 'Warnant',
    '5540': 'Hermeton-Sur-Meuse',
    '5541': 'Hastière-Par-Delà',
    '5542': 'Blaimont',
    '5543': 'Heer',
    '5544': 'Agimont',
    '5550': 'Membre',
    '5555': 'Bellefontaine',
    '5560': 'Mesnil-Saint-Blaise',
    '5561': 'Celles',
    '5562': 'Custinne',
    '5563': 'Hour',
    '5564': 'Wanlin',
    '5570': 'Wancennes',
    '5571': 'Wiesme',
    '5572': 'Focant',
    '5573': 'Martouzin-Neuville',
    '5574': 'Pondrôme',
    '5575': 'Patignies',
    '5576': 'Froidfontaine',
    '5580': 'Jemelle',
    '5590': 'Braibant',
    '5600': 'Vodecée',
    '5620': 'Morville',
    '5621': 'Hanzinne',
    '5630': 'Senzeille',
    '5640': 'Oret',
    '5641': 'Furnaux',
    '5644': 'Ermeton-Sur-Biert',
    '5646': 'Stave',
    '5650': 'Clermont',
    '5651': 'Somzée',
    '5660': 'Frasnes',
    '5670': 'Treignes',
    '5680': 'Matagne-La-Petite',
    '6000': 'Charleroi',
    '6001': 'Marcinelle',
    '6010': 'Couillet',
    '6020': 'Dampremy',
    '6030': 'Goutroux',
    '6031': 'Monceau-Sur-Sambre',
    '6032': 'Mont-Sur-Marchienne',
    '6040': 'Jumet',
    '6041': 'Gosselies',
    '6042': 'Lodelinsart',
    '6043': 'Ransart',
    '6044': 'Roux',
    '6060': 'Gilly',
    '6061': 'Montignies-Sur-Sambre',
    '6110': 'Montigny-Le-Tilleul',
    '6111': 'Landelies',
    '6120': 'Nalinnes',
    '6140': "Fontaine-L'evêque",
    '6141': 'Forchies-La-Marche',
    '6142': 'Leernes',
    '6150': 'Anderlues',
    '6180': 'Courcelles',
    '6181': 'Gouy-Lez-Piéton',
    '6182': 'Souvret',
    '6183': 'Trazegnies',
    '6200': 'Châtelineau',
    '6210': 'Wayaux',
    '6211': 'Mellet',
    '6220': 'Lambusart',
    '6221': 'Saint-Amand',
    '6222': 'Brye',
    '6223': 'Wagnelée',
    '6224': 'Wanfercée-Baulet',
    '6230': 'Obaix',
    '6238': 'Luttre',
    '6240': 'Pironchamps',
    '6250': 'Roselies',
    '6280': 'Gerpinnes',
    '6440': 'Fourbechies',
    '6441': 'Erpion',
    '6460': 'Saint-Remy',
    '6461': 'Virelles',
    '6462': 'Vaulx-Lez-Chimay',
    '6463': 'Lompret',
    '6464': 'Rièzes',
    '6470': 'Sautin',
    '6500': 'Solre-Saint-Géry',
    '6511': 'Strée',
    '6530': 'Leers-Et-Fosteau',
    '6531': 'Biesme-Sous-Thuin',
    '6532': 'Ragnies',
    '6533': 'Biercée',
    '6534': 'Gozée',
    '6536': 'Donstiennes',
    '6540': 'Mont-Sainte-Geneviève',
    '6542': 'Sars-La-Buissière',
    '6543': 'Bienne-Lez-Happart',
    '6560': 'Erquelinnes',
    '6567': 'Merbes-Le-Château',
    '6590': 'Momignies',
    '6591': 'Macon',
    '6592': 'Monceau-Imbrechies',
    '6593': 'Macquenoise',
    '6594': 'Beauwelz',
    '6596': 'Forge-Philippe',
    '6600': 'Wardin',
    '6630': 'Martelange',
    '6637': 'Tintange',
    '6640': 'Morhet',
    '6642': 'Juseret',
    '6660': 'Houffalize',
    '6661': 'Tailles',
    '6662': 'Tavigny',
    '6663': 'Mabompré',
    '6666': 'Wibrin',
    '6670': 'Gouvy',
    '6671': 'Bovigny',
    '6672': 'Beho',
    '6673': 'Cherain',
    '6674': 'Montleban',
    '6680': 'Amberloup',
    '6681': 'Lavacherie',
    '6686': 'Flamierge',
    '6687': 'Bertogne',
    '6688': 'Longchamps',
    '6690': 'Bihain',
    '6692': 'Petit-Thier',
    '6698': 'Grand-Halleux',
    '6700': 'Heinsch',
    '6704': 'Guirsch',
    '6706': 'Autelbas',
    '6717': 'Tontelange',
    '6720': 'Habay-La-Neuve',
    '6721': 'Anlier',
    '6723': 'Habay-La-Vieille',
    '6724': 'Rulles',
    '6730': 'Saint-Vincent',
    '6740': 'Etalle',
    '6741': 'Vance',
    '6742': 'Chantemelle',
    '6743': 'Buzenol',
    '6747': 'Saint-Léger',
    '6750': 'Signeulx',
    '6760': 'Ruette',
    '6761': 'Latour',
    '6762': 'Saint-Mard',
    '6767': 'Torgny',
    '6769': 'Robelmont',
    '6780': 'Wolkrange',
    '6781': 'Sélange',
    '6782': 'Habergy',
    '6790': 'Aubange',
    '6791': 'Athus',
    '6792': 'Halanzy',
    '6800': 'Bras',
    '6810': 'Jamoigne',
    '6811': 'Les Bulles',
    '6812': 'Suxy',
    '6813': 'Termes',
    '6820': 'Fontenoille',
    '6821': 'Lacuisine',
    '6823': 'Villers-Devant-Orval',
    '6824': 'Chassepierre',
    '6830': 'Poupehan',
    '6831': 'Noirfontaine',
    '6832': 'Sensenruth',
    '6833': 'Ucimont',
    '6834': 'Bellevaux',
    '6836': 'Dohan',
    '6838': 'Corbion',
    '6840': 'Grapfontaine',
    '6850': 'Offagne',
    '6851': 'Nollevaux',
    '6852': 'Maissin',
    '6853': 'Framont',
    '6856': 'Fays-Les-Veneurs',
    '6860': 'Léglise',
    '6870': 'Hatrival',
    '6880': 'Orgeo',
    '6887': 'Saint-Médard',
    '6890': 'Transinne',
    '6900': 'On',
    '6920': 'Sohier',
    '6921': 'Chanly',
    '6922': 'Halma',
    '6924': 'Lomprez',
    '6927': 'Resteigne',
    '6929': 'Daverdisse',
    '6940': 'Durbuy',
    '6941': 'Borlon',
    '6950': 'Harsin',
    '6951': 'Bande',
    '6952': 'Grune',
    '6953': 'Lesterny',
    '6960': 'Manhay',
    '6970': 'Tenneville',
    '6971': 'Champlon',
    '6972': 'Erneuville',
    '6980': 'Beausaint',
    '6982': 'Samrée',
    '6983': 'Ortho',
    '6984': 'Hives',
    '6986': 'Halleux',
    '6987': 'Hodister',
    '6990': 'Marenne',
    '6997': 'Erezée',
    '7000': 'Mons',
    '7011': 'Ghlin',
    '7012': 'Flénu',
    '7020': 'Nimy',
    '7021': 'Havre',
    '7022': 'Nouvelles',
    '7024': 'Ciply',
    '7030': 'Saint-Symphorien',
    '7031': 'Villers-Saint-Ghislain',
    '7032': 'Spiennes',
    '7033': 'Cuesmes',
    '7034': 'Saint-Denis',
    '7040': 'Aulnois',
    '7041': 'Havay',
    '7050': 'Masnuy-Saint-Pierre',
    '7060': 'Horrues',
    '7061': 'Thieusies',
    '7062': 'Naast',
    '7063': 'Neufvilles',
    '7070': 'Thieu',
    '7080': 'Noirchain',
    '7090': 'Ronquières',
    '7100': 'Trivières',
    '7110': 'Maurage',
    '7120': 'Vellereille-Le-Sec',
    '7130': 'Battignies',
    '7131': 'Waudrez',
    '7133': 'Buvrinnes',
    '7134': 'Péronnes-Lez-Binche',
    '7140': 'Morlanwelz-Mariemont',
    '7141': 'Mont-Sainte-Aldegonde',
    '7160': 'Piéton',
    '7170': 'La Hestre',
    '7180': 'Seneffe',
    '7181': 'Petit-Roeulx-Lez-Nivelles',
    '7190': 'Ecaussinnes',
    '7191': 'Ecaussinnes-Lalaing',
    '7300': 'Boussu',
    '7301': 'Hornu',
    '7320': 'Bernissart',
    '7321': 'Blaton',
    '7322': 'Pommeroeul',
    '7330': 'Saint-Ghislain',
    '7331': 'Baudour',
    '7332': 'Neufmaison',
    '7333': 'Tertre',
    '7334': 'Hautrage',
    '7340': 'Wasmes',
    '7350': 'Montroeul-Sur-Haine',
    '7370': 'Dour',
    '7380': 'Quiévrain',
    '7382': 'Audregnies',
    '7387': 'Roisin',
    '7390': 'Wasmuel',
    '7500': 'Tournai',
    '7501': 'Orcq',
    '7502': 'Esplechin',
    '7503': 'Froyennes',
    '7504': 'Froidmont',
    '7506': 'Willemeau',
    '7520': 'Templeuve',
    '7521': 'Chercq',
    '7522': 'Marquain',
    '7530': 'Gaurain-Ramecroix',
    '7531': 'Havinnes',
    '7532': 'Beclers',
    '7533': 'Thimougies',
    '7534': 'Barry',
    '7536': 'Vaulx',
    '7538': 'Vezon',
    '7540': 'Rumillies',
    '7542': 'Mont-Saint-Aubert',
    '7543': 'Mourcourt',
    '7548': 'Warchin',
    '7600': 'Péruwelz',
    '7601': 'Roucourt',
    '7602': 'Bury',
    '7603': 'Bon-Secours',
    '7604': 'Wasmes-Audemez-Briffoeil',
    '7608': 'Wiers',
    '7610': 'Rumes',
    '7611': 'La Glanerie',
    '7618': 'Taintignies',
    '7620': 'Jollain-Merlin',
    '7621': 'Lesdain',
    '7622': 'Laplaigne',
    '7623': 'Rongy',
    '7624': 'Howardries',
    '7640': 'Maubray',
    '7641': 'Bruyelle',
    '7642': 'Calonne',
    '7643': 'Fontenoy',
    '7700': 'Mouscron',
    '7711': 'Dottignies',
    '7712': 'Herseaux',
    '7730': 'Evregnies',
    '7740': 'Warcoing',
    '7742': 'Hérinnes-Lez-Pecq',
    '7743': 'Obigies',
    '7750': 'Orroir',
    '7760': 'Velaines',
    '7780': 'Comines-Warneton',
    '7781': 'Houthem',
    '7782': 'Ploegsteert',
    '7783': 'Bizet',
    '7784': 'Bas-Warneton',
    '7800': 'Ath',
    '7801': 'Irchonwelz',
    '7802': 'Ormeignies',
    '7803': 'Bouvignies',
    '7804': 'Rebaix',
    '7810': 'Maffle',
    '7811': 'Arbre',
    '7812': 'Villers-Saint-Amand',
    '7822': 'Ghislenghien',
    '7823': 'Gibecq',
    '7830': 'Thoricourt',
    '7850': 'Petit-Enghien',
    '7860': 'Lessines',
    '7861': 'Papignies',
    '7862': 'Ogy',
    '7863': 'Ghoy',
    '7864': 'Deux-Acren',
    '7866': 'Ollignies',
    '7870': 'Lombise',
    '7880': 'Flobecq',
    '7890': 'Ellezelles',
    '7900': 'Leuze-En-Hainaut',
    '7901': 'Thieulain',
    '7903': 'Blicquy',
    '7904': 'Pipaix',
    '7906': 'Gallaix',
    '7910': 'Forest',
    '7911': 'Oeudeghien',
    '7912': 'Dergneau',
    '7940': 'Cambron-Casteau',
    '7941': 'Attre',
    '7942': 'Mévergnies-Lez-Lens',
    '7943': 'Gages',
    '7950': 'Ladeuze',
    '7951': 'Tongre-Notre-Dame',
    '7970': 'Beloeil',
    '7971': 'Wadelincourt',
    '7972': 'Quevaucamps',
    '7973': 'Stambruges',
    '8000': 'Koolkerke',
    '8020': 'Oostkamp',
    '8200': 'Sint-Andries',
    '8210': 'Zedelgem',
    '8211': 'Aartrijke',
    '8300': 'Knokke',
    '8301': 'Ramskapelle',
    '8310': 'Sint-Kruis',
    '8340': 'Sijsele',
    '8370': 'Uitkerke',
    '8377': 'Houtave',
    '8380': 'Zeebrugge',
    '8400': 'Zandvoorde',
    '8420': 'Klemskerke',
    '8421': 'Vlissegem',
    '8430': 'Middelkerke',
    '8431': 'Wilskerke',
    '8432': 'Leffinge',
    '8433': 'Schore',
    '8434': 'Lombardsijde',
    '8450': 'Bredene',
    '8460': 'Oudenburg',
    '8470': 'Zevekote',
    '8480': 'Eernegem',
    '8490': 'Zerkegem',
    '8500': 'Kortrijk',
    '8501': 'Heule',
    '8510': 'Rollegem',
    '8511': 'Aalbeke',
    '8520': 'Kuurne',
    '8530': 'Harelbeke',
    '8531': 'Bavikhove',
    '8540': 'Deerlijk',
    '8550': 'Zwevegem',
    '8551': 'Heestert',
    '8552': 'Moen',
    '8553': 'Otegem',
    '8554': 'Sint-Denijs',
    '8560': 'Moorsele',
    '8570': 'Anzegem',
    '8572': 'Kaster',
    '8573': 'Tiegem',
    '8580': 'Avelgem',
    '8581': 'Waarmaarde',
    '8582': 'Outrijve',
    '8583': 'Bossuit',
    '8587': 'Espierres',
    '8600': 'Driekapellen',
    '8610': 'Zarren',
    '8620': 'Sint-Joris',
    '8630': 'Wulveringem',
    '8640': 'Oostvleteren',
    '8647': 'Reninge',
    '8650': 'Merkem',
    '8660': 'Adinkerke',
    '8670': 'Oostduinkerke',
    '8680': 'Zande',
    '8690': 'Hoogstade',
    '8691': 'Stavele',
    '8700': 'Aarsele',
    '8710': 'Ooigem',
    '8720': 'Wakken',
    '8730': 'Sint-Joris',
    '8740': 'Egem',
    '8750': 'Zwevezele',
    '8755': 'Ruiselede',
    '8760': 'Meulebeke',
    '8770': 'Ingelmunster',
    '8780': 'Oostrozebeke',
    '8790': 'Waregem',
    '8791': 'Beveren',
    '8792': 'Desselgem',
    '8793': 'Sint-Eloois-Vijve',
    '8800': 'Roeselare',
    '8810': 'Lichtervelde',
    '8820': 'Torhout',
    '8830': 'Gits',
    '8840': 'Westrozebeke',
    '8850': 'Ardooie',
    '8851': 'Koolskamp',
    '8860': 'Lendelede',
    '8870': 'Emelgem',
    '8880': 'Sint-Eloois-Winkel',
    '8890': 'Moorslede',
    '8900': 'Brielen',
    '8902': 'Hollebeke',
    '8904': 'Zuidschote',
    '8906': 'Elverdinge',
    '8908': 'Vlamertinge',
    '8920': 'Poelkapelle',
    '8930': 'Lauwe',
    '8940': 'Geluwe',
    '8950': 'Nieuwkerke',
    '8951': 'Dranouter',
    '8952': 'Wulvergem',
    '8953': 'Wijtschate',
    '8954': 'Westouter',
    '8956': 'Kemmel',
    '8957': 'Messines',
    '8958': 'Loker',
    '8970': 'Reningelst',
    '8972': 'Proven',
    '8978': 'Watou',
    '8980': 'Geluveld',
    '9000': 'Gent',
    '9030': 'Mariakerke',
    '9031': 'Drongen',
    '9032': 'Wondelgem',
    '9040': 'Sint-Amandsberg',
    '9041': 'Oostakker',
    '9042': 'Desteldonk',
    '9050': 'Gentbrugge',
    '9051': 'Afsnee',
    '9052': 'Zwijnaarde',
    '9060': 'Zelzate',
    '9070': 'Heusden',
    '9080': 'Zaffelare',
    '9090': 'Gontrode',
    '9100': 'Sint-Niklaas',
    '9111': 'Belsele',
    '9112': 'Sinaai-Waas',
    '9120': 'Vrasene',
    '9130': 'Kieldrecht',
    '9140': 'Tielrode',
    '9150': 'Kruibeke',
    '9160': 'Daknam',
    '9170': 'De Klinge',
    '9180': 'Moerbeke-Waas',
    '9185': 'Wachtebeke',
    '9190': 'Stekene',
    '9200': 'Schoonaarde',
    '9220': 'Moerzeke',
    '9230': 'Wetteren',
    '9240': 'Zele',
    '9250': 'Waasmunster',
    '9255': 'Opdorp',
    '9260': 'Schellebelle',
    '9270': 'Kalken',
    '9280': 'Lebbeke',
    '9290': 'Overmere',
    '9300': 'Aalst',
    '9308': 'Hofstade',
    '9310': 'Moorsel',
    '9320': 'Nieuwerkerken',
    '9340': 'Wanzele',
    '9400': 'Lieferinge',
    '9401': 'Pollare',
    '9402': 'Meerbeke',
    '9403': 'Neigem',
    '9404': 'Aspelare',
    '9406': 'Outer',
    '9420': 'Erpe-Mere',
    '9450': 'Heldergem',
    '9451': 'Kerksken',
    '9470': 'Denderleeuw',
    '9472': 'Iddergem',
    '9473': 'Welle',
    '9500': 'Overboelare',
    '9506': 'Idegem',
    '9520': 'Oombergen',
    '9521': 'Letterhoutem',
    '9550': 'Steenhuize-Wijnhuize',
    '9551': 'Ressegem',
    '9552': 'Borsbeke',
    '9570': 'Deftinge',
    '9571': 'Hemelveerdegem',
    '9572': 'Sint-Martens-Lierde',
    '9600': 'Renaix',
    '9620': 'Velzeke-Ruddershove',
    '9630': 'Sint-Maria-Latem',
    '9636': 'Nederzwalm-Hermelgem',
    '9660': 'Nederbrakel',
    '9661': 'Parike',
    '9667': 'Horebeke',
    '9680': 'Maarkedal',
    '9681': 'Nukerke',
    '9688': 'Schorisse',
    '9690': 'Ruien',
    '9700': 'Mater',
    '9750': 'Huise',
    '9770': 'Kruishoutem',
    '9771': 'Nokere',
    '9772': 'Wannegem-Lede',
    '9790': 'Wortegem',
    '9800': 'Sint-Martens-Leerne',
    '9810': 'Nazareth',
    '9820': 'Melsen',
    '9830': 'Sint-Martens-Latem',
    '9831': 'Deurle',
    '9840': 'Zevergem',
    '9850': 'Hansbeke',
    '9860': 'Landskouter',
    '9870': 'Olsene',
    '9880': 'Poeke',
    '9881': 'Bellem',
    '9890': 'Gavere',
    '9900': 'Eeklo',
    '9910': 'Ursel',
    '9920': 'Lovendegem',
    '9921': 'Vinderhoute',
    '9930': 'Zomergem',
    '9931': 'Oostwinkel',
    '9932': 'Ronsele',
    '9940': 'Kluizen',
    '9950': 'Waarschoot',
    '9960': 'Assenede',
    '9961': 'Boekhoute',
    '9968': 'Bassevelde',
    '9970': 'Kaprijke',
    '9971': 'Lembeke',
    '9980': 'Sint-Laureins',
    '9981': 'Sint-Margriete',
    '9982': 'Sint-Jan-In-Eremo',
    '9988': 'Waterland-Oudeman',
    '9990': 'Maldegem',
    '9991': 'Adegem',
    '9992': 'Middelburg'
}[postalCode])